import React, { forwardRef, useState } from "react";
import { GiConvergenceTarget } from "react-icons/gi";
import {
  CenterFocusStrong,
  Edit,
  EditNote,
  FitScreenRounded,
} from "@mui/icons-material";
import {
  Box,
  Button,
  FormControlLabel,
  Switch,
  ToggleButton,
  Tooltip,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { I18n } from "aws-amplify/utils";

const EditButton = ({ onEdit, isEditMode }) => {
  const [selected, setSelected] = useState(false);
  const handleChange = () => {
    setSelected((prev) => !prev); //inverte lo stato
  };
  const hoverBtnDescription = (
    <p style={{ fontSize: "1rem", margin: 0 }}>Edit mode</p>
  );

  return (
    <div>
      <Tooltip
        title={hoverBtnDescription}
        disableinteractive="true"
        slotprops={{
          tooltip: {
            sx: {
              bgcolor: "#545859",
            },
          },
        }}
      >
        <Box display="flex" alignItems="center" gap={1}>
          <Typography>{I18n.get("Edit mode:")}</Typography>
          <Switch
            checked={isEditMode}
            onChange={onEdit}
            sx={{
              margin: 0,
              "& .Mui-checked + .MuiSwitch-track": {
                backgroundColor: "#bdd5f0 !important",
                borderColor: "#90b6de !important",
              },
              "& .MuiSwitch-track":{
                borderColor: "#9e9e9e !important",
              }
            }}
            icon={
              <Edit
                sx={{
                  backgroundColor: "#f0f0f0",
                  borderRadius: "50%",
                  padding: "4px",
                  boxShadow: "0 0 0 1px rgba(0,0,0,0.2)",
                  color: "#9e9e9e",
                }}
              />
            }
            checkedIcon={
              <Edit
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "50%",
                  padding: "4px",
                  boxShadow: "0 0 0 1px rgba(0,0,0,0.2)",
                  color: "#00449e",
                }}
              />
            }
          />
        </Box>
      </Tooltip>
    </div>
  );
};

export default EditButton;
